<!-- <div class="template3">
    <section class="position-relative h-100">
        <div class="row m-0 notfound-block">
            <div class="col-12 my-auto">
                <div class="row col-12 col-xl-9 mx-auto">
                    <div class="col-12 col-lg-4 text-center heading-font my-auto">Oops!</div>
                    <div class="col-12 order-lg-12 col-lg-4 text-center heading-font mt-8 ">404</div>
                    <div class="col-12 order-lg-2 col-lg-4 text-center">
                        <img src="{{s3BucketUrl}}/flpi/images/forever-titan-aloe.png" />
                        <div class="pagenotfound-text">{{'common.Page not found' | translate | translateKey}}</div>
                        <div class="helful-links mt-3">{{'common.Here are some helpful links instead' | translate | translateKey}}:</div>
                        <div class="footer-link">
                            <ul>
                                <li>{{'common.Home' | translate | translateKey}}</li>
                                <li>{{'common.Search' | translate | translateKey}}</li>
                                <li>{{'common.Help' | translate | translateKey}}</li>
                                <li>{{'common.Site Map' | translate | translateKey}}</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</div> -->
<div titan-page-not-found></div>
<div class="template3" *ngIf="contenthtml">
    <div [innerHTML]="contenthtml | safeHtml" appDynamicNavigation (isNavClicked)="navigateToPortal($event)"></div>
</div>
